import Repository from 'helpers/Repository';
import { ChartTypesUnion, IFormValues } from 'types/Analytics';
import { TIME_UNITS, groupPeriodBy } from 'constants/dateFormats';

const isOperationDmsEnabled = (): boolean => {
  const { user } = Repository.get('store').getState();

  return user.isOperationDmsFilterEnabled;
};

const isGraph = (chartType: ChartTypesUnion): boolean => {
  return (
    chartType === 'pie chart' ||
    chartType === 'bar' ||
    chartType === 'horizontal_bar' ||
    chartType === 'line'
  );
};

const MAX_DAYS_FOR_HOURLY = TIME_UNITS.DAYS_PER_WEEK;

/**
 * Если groupByDate переключён на '1h' и relative-период превышает 7 дней —
 * сбрасывает period до '-7 days'.
 * Используется как onChangeCallback для поля groupByDate во всех form configs.
 */
const clampRelativePeriodForGroupByDate = (values: IFormValues): IFormValues => {
  if (!('groupByDate' in values && 'period' in values) || values.groupByDate !== groupPeriodBy.Hour) {
    return values;
  }

  const period = values.period;

  if (!period || typeof period !== 'object' || !('relative' in period)) {
    return values;
  }

  const relative = period.relative;
  const match = relative.match(/^-(\d+) (hour|day|week|month)s?$/);

  if (!match) return values;

  const n = Number(match[1]);
  const unit = match[2];
  const days =
    unit === 'hour'  ? n / TIME_UNITS.HOURS_PER_DAY :
    unit === 'day'   ? n :
    unit === 'week'  ? n * TIME_UNITS.DAYS_PER_WEEK :
    n * TIME_UNITS.APPROX_DAYS_PER_MONTH;

  if (days > MAX_DAYS_FOR_HOURLY) {
    return { ...values, period: { relative: `-${MAX_DAYS_FOR_HOURLY} days` } };
  }

  return values;
};

export { isOperationDmsEnabled, isGraph, clampRelativePeriodForGroupByDate };
